import { render, staticRenderFns } from "./ViewStaff.vue?vue&type=template&id=da0c88d2&scoped=true"
import script from "./ViewStaff.vue?vue&type=script&lang=js"
export * from "./ViewStaff.vue?vue&type=script&lang=js"
import style0 from "./ViewStaff.vue?vue&type=style&index=0&id=da0c88d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0c88d2",
  null
  
)

export default component.exports